import SignUpContainer from "../components/pageComponents/Login/SignUpContainer";

const SignUp=()=>{
    return(<div><SignUpContainer /></div>);
}
export default SignUp;